import React, { Component } from "react";

import { FormControl, FormGroup, Button, InputGroup } from "react-bootstrap";

import './Search.css';

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = { value: this.props.userQuery };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.handleSubmit(0);
    }

    render() {

    	const bsSize = this.props.bsSize ? this.props.bsSize : undefined;

        let searchLabel = "Search";

        if (this.props.loading) {
            searchLabel = "Searching...";
        }
		let selectedPageScope = this.props.options.scope.find((option) => option.selected === true);
        let optionsLabel = selectedPageScope.name;


        return (
            <div className="Search">
                <form onSubmit={this.handleSubmit}>
                    <FormGroup bsSize={bsSize}>
                        <InputGroup>
                            <InputGroup.Button>
                                <Button
                                    bsStyle="info"
                                    { ...bsSize ? {bsSize: bsSize} : {}}
                                    onClick={this.props.handleOptionsClick}
                                >
                                    {optionsLabel} <span className="caret" />
                                </Button>
                            </InputGroup.Button>
                            <FormControl
                                type="text"
                                placeholder="Search, e.g. bootstrap.min.js"
                                value={this.props.userQuery}
                                onChange={this.props.handleQueryChange}
                                style={{borderColor: "#5bc0de"}}
                                pattern=".{3,50}" 
                                required 
                                title="3 to 50 characters"
                            />
                            <InputGroup.Button>
                                <Button
                                    disabled={this.props.loading}
                                    type="submit"
                                    bsStyle="success"
                                    bsSize={bsSize}
                                >
                                    {searchLabel}
                                </Button>
                            </InputGroup.Button>
                        </InputGroup>
                    </FormGroup>
                </form>
            </div>
        );
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/Search.js